import { MenuItem, SelectChangeEvent, styled, Typography } from "@mui/material";
import { InlineSelect } from "components/form/InlineSelect";
import { useSortOptions, useUrlSort } from "hooks/filterHooks";
import { useTranslation } from "react-i18next";

export function SortSelection() {
  const { t } = useTranslation();
  const { selectedSortOption, updateSort } = useUrlSort();
  const sortOptions = useSortOptions();

  function onSelectChange(event: SelectChangeEvent<string>) {
    const { value } = event.target;
    updateSort(value);
  }
  return (
    <StyledTypography variant="subtitle1" noWrap>
      {t("label.sortBy")}:
      <InlineSelect<string>
        value={selectedSortOption.value}
        onChange={onSelectChange}
        sx={{ fontSize: "inherit" }}
      >
        {sortOptions.map((sortOption) => (
          <MenuItem key={sortOption.value} value={sortOption.value}>
            {sortOption.label}
          </MenuItem>
        ))}
      </InlineSelect>
    </StyledTypography>
  );
}

const StyledTypography = styled(Typography)`
  display: inline-flex;
  align-items: center;

  .MuiSelect-select {
    padding-left: ${({ theme }) => theme.spacing(1)};
  }
`;
